module.exports = __webpack_public_path__ + "img/emp2-2.af2bab10.jpg";